import { isCollectPlusRelatedType } from './getCollectPlusRelatedStores';

export default function isCollectionPointAvailable(collectionPoint = {}, deliveryOptions = {}) {
  const collectPlusAvailable = deliveryOptions?.collectPlusAvailable;

  if (!collectPlusAvailable && isCollectPlusRelatedType(collectionPoint.ownerId)) return false;

  return collectionPoint.isAvailable;
}
